/**
 * Utility function to consistently translate role names across the application
 * @param {string|object} role - The role to translate (can be a string or object with name property)
 * @param {function} t - The translation function from react-i18next
 * @returns {string} - The translated role name
 */
export const translateRole = (role, t) => {
  // Handle null/undefined cases
  if (!role) {
    return t('User');
  }

  // Extract role name if it's an object
  const roleName = typeof role === 'object' ? role.name : role;
  
  if (!roleName) {
    return t('User');
  }

  // List of specific medical/professional roles that should be translated directly
  const specificRoles = [
    'Doctor',
    'Nurse', 
    'Pharmacist',
    'Physiotherapist',
    'Psychologist',
    'Specialist',
    'Therapist',
    'Team Lead',
    'Team Leader',
    'Coordinator',
    'Care Coordinator',
    'Primary Physician',
    'Specialist Consultant'
  ];

  // Check if it's a specific role that should be translated
  if (specificRoles.includes(roleName)) {
    return t(roleName);
  }

  // Handle generic role types with specific translations
  switch (roleName?.toLowerCase()) {
    case 'administrator':
      return t('Administrator');
    case 'super_admin':
      return t('Super Admin');
    case 'medical':
    case 'external':
      // If we still have generic types, show them but translated
      return t('Medical Professional');
    default:
      // For any other role, try to translate it or show as-is
      const translated = t(roleName);
      return translated !== roleName ? translated : roleName;
  }
};

export default translateRole;